import { render, staticRenderFns } from "./rema-domain-select.vue?vue&type=template&id=44c4fa01&scoped=true"
import script from "./rema-domain-select.vue?vue&type=script&lang=js"
export * from "./rema-domain-select.vue?vue&type=script&lang=js"
import style0 from "./rema-domain-select.vue?vue&type=style&index=0&id=44c4fa01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4fa01",
  null
  
)

export default component.exports